import { IAccount } from "@core/models";

export const AccountInfomationsMocks = {
  [IAccount.firstname]: "Test",
  [IAccount.lastname]: "Extracadabra",
  [IAccount.email]: "contact@extracadabra.com",
  [IAccount.phone]: "0123456789",
};
